module.exports = __webpack_public_path__ + "static/media/mm.9f9bceeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mm.png
// module id = 1924
// module chunks = 0